module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--7-bc3587db573f235f07095ee0a0cdbe24.jpg";